import React, { useState, useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
// Import Shared Utils
import { get } from 'shared-components/src/utils/http';
// Import Contexts
import { ProgramConfigContext } from '../../../contexts/ProgramConfigContext';
// Import Global Components
import Button from '../../../components/Button';
// Import Global Hooks
import useAlert from '../../../hooks/useAlert';
// Import Translations
import { profileEn } from '../../../i18n/profile';
// Import Profile Components (same PIN retrieval flow as My Profile)
import GetPinModal from '../../Profile/components/GetPinModal';
import GetGalileoPinModal from '../../Profile/components/GetGalileoPinModal';

const ViewPinButton = ({ currentAccount }) => {
  // modal states
  const [showGetPinModal, setShowGetPinModal] = useState(false);
  // component states
  const [pinModalAlert, setPinModalAlert] = useAlert();
  const [pin, setPin] = useState(null);
  const [programProcessor, setProgramProcessor] = useState(null);
  // GetPinModal is unmounted & remounted whenever an error occurs
  // to ensure useEffect within GetPinModal only runs once, use initialPinFetch
  const initialPinFetch = useRef(true);

  const programConfigs = useContext(ProgramConfigContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const processorData = await get(
          '/api/v1/cardholder_portal/cardholder/program_processor'
        );

        setProgramProcessor(processorData.data);
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    };

    fetchData();
  }, []);

  const isPinViewEnabled = programConfigs && programConfigs.pin_view_enabled;
  const allowSensitiveDataToken =
    programConfigs && programConfigs.allow_sensitive_data_token;

  if (!isPinViewEnabled) return null;

  const toggleGetPinModal = e => {
    e.preventDefault();
    if (!showGetPinModal) {
      initialPinFetch.current = true;
    }
    setShowGetPinModal(!showGetPinModal);
  };

  const isNotGalileo =
    programProcessor && programProcessor.processor_name !== 'galileo';
  const isGalileo =
    programProcessor && programProcessor.processor_name === 'galileo';

  return (
    <>
      <Button
        buttonText={profileEn['profile-view-pin-button']}
        page="profile"
        type="secondary"
        size="large"
        buttonFor="view-pin"
        onClick={e => toggleGetPinModal(e)}
      />
      {showGetPinModal && isNotGalileo && (
        <GetPinModal
          currentAccount={currentAccount}
          toggleModal={toggleGetPinModal}
          pin={pin}
          setPin={setPin}
          alert={pinModalAlert}
          setAlert={setPinModalAlert}
          initialPinFetch={initialPinFetch}
          allowSensitiveDataToken={!!allowSensitiveDataToken}
        />
      )}
      {showGetPinModal && isGalileo && (
        <GetGalileoPinModal
          currentAccount={currentAccount}
          toggleModal={toggleGetPinModal}
        />
      )}
    </>
  );
};

ViewPinButton.propTypes = {
  currentAccount: PropTypes.shape({
    id: PropTypes.number.isRequired,
    cards: PropTypes.array.isRequired, //eslint-disable-line
  }).isRequired,
};

export default ViewPinButton;
